import { filter } from 'rxjs/operators';

import { Injectable } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

import { NotificationConfig } from './notification-config.model';
import { NotificationDialogComponent } from './notification-dialog.component';

/**
 * Used to solicit user feedback to confirm an action.
 *
 * @export
 * @class NotificationService
 */
@Injectable()
export class NotificationService {
  private modal: NgbModalRef;

  constructor(
    private modalService: NgbModal,
    private router: Router,
  ) {
    // automatically close the modal on route change
    this.router.events.pipe(filter((event) => event instanceof NavigationStart)).subscribe(() => {
      this.close(false);
    });
  }

  /**
   *
   *
   * Notify the user and request aknowledgement.
   *
   *
   *
   * @param config
   * @returns Did the user aknowledge?
   * @memberof NotificationService
   */
  public notify(config: NotificationConfig): Promise<void> {
    this.close(false);
    // so that we can disable closing the modal during processing
    const modalOptions = {
      backdrop: 'static',
      keyboard: false,
    } as NgbModalOptions;
    this.modal = this.modalService.open(NotificationDialogComponent, modalOptions);
    const component = this.modal.componentInstance as NotificationDialogComponent;
    component.config = config;
    const promise = new Promise<void>((resolve) => {
      this.modal.result
        .then(() => {
          resolve();
        })
        .catch(() => {
          resolve();
        })
        .then(() => {
          this.modal = null;
        });
    });
    return promise;
  }

  public close(isConfirmed: boolean): void {
    if (this.modal) {
      this.modal.close(isConfirmed);
      this.modal = null;
    }
  }
}
